import React from "react";
import { Spin } from "antd";
import { SyncOutlined } from "@ant-design/icons";

const Loader = ({ size = "large", color = "#008CF0", text = null }) => {
  const antIcon = (
    <SyncOutlined
      style={{ fontSize: size === "large" ? 50 : 30, color }}
      spin
    />
  );
  return (
    <div className="loaderBox">
      <Spin indicator={antIcon} />
      {text && <div className="loader_text" >{text}</div>}
    </div>
  );
};


export default Loader;